const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 270,
    minWidth: 500,
    maxWidth: minWidth / 1.5,
    maxHeight: 400 
  },
  modalHeader: {
    fontWeight:'600!important',
    fontSize: '1.2rem!important',
  },
  form: {
    height: 430,
    overflow: 'hidden'
  },
  flex: {
    flex: 1
  },
  scrollableList: {
    maxHeight: 140,
    overflowY: 'scroll'
  },
  summary: {
    padding: theme.spacing.unit
  },
  warning: {
    color: '#9F6000',
    backgroundColor: '#FEEFB3',
    padding: 10,
    textAlign: 'center'
  },
  submit: {
    textTransform: "none",
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    marginTop: 10,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding:0,
    minWidth:40,
  },
  upload: {
    '@supports ((-moz-appearance:none) or (-webkit-appearance:none))': {
      '& input': {
        height: '2em',
      },
    }
  },
  scrollableList: {
    maxHeight: 140,
    overflow: 'auto',
    '& li': {
      '&:nth-child(odd)': {
        backgroundColor: '#F7F7F7'
      },
    },
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    marginTop: 15,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles
